$(function () {
    initMap1();
    initHero();
    initSmoothScroll();
    initSearch();
    initNav();
    initSlick();
    initAanbodSlider();
    initNewsSlider();
    initUsps();
    initDetails();
    // initContact();
    initAanbod();
    initHuisVerkopen();
    initTimeline();
    initServices();
    initMatchheight();
    villaProjects();

    // setTimeout(() => {
    //     googleTranslateElementInit();
    //     loadStoredLanguage();
    //
    //
    //     const skiptranslate = document.querySelector('.skiptranslate');
    //
    //     if (skiptranslate) {
    //         skiptranslate.style.display = 'none';
    //         document.body.style.top = '0';
    //     }
    // }, 1000);
    // initLanguageToggle();
});

function Global() {
    var self = this;
    setTimeout(function() {
        self.googleTranslateElementInit();
        self.loadStoredLanguage();
        var skiptranslate = document.querySelector('.skiptranslate');
        if (skiptranslate) {
            skiptranslate.style.display = 'none';
            document.body.style.top = '0';
        }
    }, 1000);
    this.initLanguageToggle();
}

Global.prototype.googleTranslateElementInit = function() {
    new google.translate.TranslateElement({
        pageLanguage: 'nl',
        layout: google.translate.TranslateElement.InlineLayout.SIMPLE
    }, 'google_translate_element');
};

Global.prototype.handleLanguage = function(language, imagePath, languageName) {
    console.log(language, imagePath, languageName);
    var selectField = document.querySelector("select.goog-te-combo");
    if (selectField) {
        selectField.value = language;
        selectField.dispatchEvent(new Event('change'));
    }
    document.getElementById("currentLanguageImg").src = imagePath;
    document.getElementById("currentLanguageImg").alt = languageName;
    if (language !== 'nl') {
        sessionStorage.setItem('selectedLanguage', JSON.stringify({
            language: language,
            imagePath: imagePath,
            languageName: languageName
        }));
    } else {
        sessionStorage.removeItem('selectedLanguage');
    }
    this.userSelectedLanguage = true;
    sessionStorage.setItem('userSelectedLanguage', true);
    setTimeout(function() {
        var skiptranslate = document.querySelector('.skiptranslate');
        if (skiptranslate) {
            skiptranslate.style.display = 'none';
            document.body.style.top = '0';
        }
    }, 1000);
};

Global.prototype.loadStoredLanguage = function() {
    var storedLang = sessionStorage.getItem('selectedLanguage');
    var userSelectedLanguage = sessionStorage.getItem('userSelectedLanguage');
    if (storedLang && userSelectedLanguage) {
        var parsedLang = JSON.parse(storedLang);
        this.handleLanguage(parsedLang.language, parsedLang.imagePath, parsedLang.languageName);
    }
};

Global.prototype.changeLanguage = function(language, imagePath, languageName) {
    this.handleLanguage(language, imagePath, languageName);
};

Global.prototype.initLanguageToggle = function() { 
    var self = this;
    document.querySelector('.lang-display').addEventListener('click', function() {
        var currentLanguageImg = document.getElementById('currentLanguageImg');
        var currentLanguage = currentLanguageImg.alt;
        if (currentLanguage === 'Nederlands') {
            self.changeLanguage('en', "/img/flag_nl.png", 'English');
        } else {
            self.changeLanguage('nl', "/img/flag_uk.png", 'Nederlands');
        }
    });
};

var globalInstance = new Global();
window.changeLanguage = function(language, imagePath, languageName) {
    globalInstance.changeLanguage(language, imagePath, languageName);
};

$(window).resize(function () {
    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function () {
        $nav.children('ul').attr('style', false);
        initTimeline();
    }, 200));
});

function initMap1() {
    if (document.querySelector('#villaanna')) {
        google.maps.event.addDomListener(window, 'load', init);
    }
    function init() {

        var mapOptions = {
            zoom: 14,
            center: new google.maps.LatLng(52.1056368, 4.2677007), // New York

            styles: [
                {
                    "featureType": "all",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "weight": "2.00"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#9c9c9c"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#eeeeee"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#7b7b7b"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#C8D8D4"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#C8D8D4"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#C8D8D4"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#C8D8D4"
                        }
                    ]
                }
            ]
        };

        // Get the HTML DOM element that will contain your map
        // We are using a div with id="map" seen below in the <body>
        var mapElement = document.getElementById('map');

        // Create the Google Map using our element and options defined above
        var map = new google.maps.Map(mapElement, mapOptions);

        const icon = new google.maps.MarkerImage(
            '/img/map-marker.svg',
            null, /* size is determined at runtime */
            null, /* origin is 0,0 */
            null, /* anchor is bottom center of the scaled image */
            new google.maps.Size(75, 75)
        );

        // Let's also add a marker while we're at it
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(52.1107696, 4.2828056),
            map: map,
            title: 'Snazzy!',
            icon: icon
        });
    }
}

function initHero() {
    if (document.querySelector('#villaanna #hero')) {
        $('.slider').slick({
            prevArrow: '.arrow_prev',
            nextArrow: '.arrow_next',
            autoplay: true,
            autoplaySpeed: 5000,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });

    }
}

function initSmoothScroll() {
    const buttons = document.querySelectorAll('.smooth-scroll');

    buttons.forEach(function (el, i) {
        el.addEventListener('click', function (ev) {
            ev.preventDefault();

            let item = document.querySelector(el.getAttribute('href'));
            let offset = item.offsetTop - document.querySelector('header').offsetHeight;

            if (document.querySelector('#property')) {
                offset -= document.querySelector('#property nav').offsetHeight;
            }
            console.log(offset)
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': offset
            });
        });
    });
}

function initNav() {
    $btn_navigation = $('header .nav-toggle');
    $nav = $('header nav');

    $btn_navigation.click(function (e) {
        e.stopPropagation();
        e.preventDefault();

        if ($(window).width() < 768) {
            if ($('#search').length > 0) {
                $('#search').slideUp(function () {
                    $nav.slideToggle();
                });
            } else {
                $nav.slideToggle();

            }
        }
    });

    if ($nav.find('ul').length > 0) {
        $li = $nav.find('li');

        $li.has('ul').children('a').click(function (e) {

            $(this).closest('ul').children('li').find('ul').each(function (i, ul) {
                if ($(ul) != $(this).next('ul')) {
                    $(this).prev('a').children('span').removeClass('toggle')
                    $(ul).slideUp();
                }
            });

            if ($(this).next('ul').is(':hidden')) {
                e.preventDefault();
                $(this).next('ul').slideDown();
                $(this).children('span').addClass('toggle')
            }
        });
    }
}

function initSearch() {
    $btn_search = $('header .search-toggle');
    $search = $('#search');

    if ($search.length == 0) {
        $btn_search.hide();
    } else {

        $btn_search.click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($(window).width() < 768) {
                $('header nav').slideUp(function () {
                    $search.slideToggle();
                });
            }
        });

        $('select#plaats option').first().text('Kies een plaats');
        $('select#prijs_min option').first().text('Minimum prijs');
        $('select#prijs_max option').first().text('Maximum prijs');
        $('select#prijs_min_huur option').first().text('Minimum prijs');
        $('select#prijs_max_huur option').first().text('Maximum prijs');

        $select_koophuur = $('#koophuur');
        $select_koophuur.change(function () {
            if ($select_koophuur.val() == 'koop') {
                $('#search-huurprijs select').attr('disabled', 'disabled');
                $('#search-koopprijs select').removeAttr('disabled');
                $('#search-huurprijs').hide();
                $('#search-koopprijs').show();
            } else {
                $('#search-koopprijs select').attr('disabled', 'disabled');
                $('#search-huurprijs select').removeAttr('disabled');
                $('#search-koopprijs').hide();
                $('#search-huurprijs').show();
            }
        });
        $select_koophuur.change();
    }
}

function initSlick() {
    if ($('#carousel').length > 0) {
        $('#carousel').slick({
            dots: true,
            arrows: false,
            autoplay: true
        });
    }
}

function initAanbodSlider() {
    if ($('#aanbod-slider').length > 0) {
        $('#aanbod-slider').slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            focusOnSelect: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

        $('#aanbod-slider .sub_slider').slick({
            fade: true,
            dots: false,
            arrows: false,
            infinite: true,
            speed: 1000,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            swipe: false
        });
    }
}

function initUsps() {
    if ($('#usps').length > 0) {
        $('#usps').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
}

function initNewsSlider() {
    if ($('#news_slider').length > 0) {
        $('#news_slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }
}

function initDetails() {
    if ($('#details').length > 0) {
        initDetailSlider();
        initDetailButtons();
        initDetailOmschrijving();
        // initStreetview();
        // initMaps();
        initObjectPano();

        if ($('.lightbox').length > 0) {
            $('.lightbox').magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        }
    }
}

function initDetailButtons() {
    if ($('.detail_buttons').length > 0) {
        var sections = {},
            offset = $('header').outerHeight() + 10;

        $('.detail_buttons a').click(function () {
            $('.detail_buttons li').removeClass('active');
            $(this).parent().addClass('active');

            // adjust for fixed header
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                && location.hostname == this.hostname) {

                var target = $(this.hash);
                target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - offset
                    }, 1000);
                    return false;
                }
            }
        });

        $('.detail_buttons a').each(function () {
            id = $(this).attr('href');

            if (id !== '#') {
                sections[id] = $(id).offset().top;
            }
        });

        $(document).scroll(function () {
            var pos = $(this).scrollTop();

            for (key in sections) {
                if (sections[key] > pos && sections[key] < pos + offset) {
                    $('.detail_buttons li').removeClass('active');
                    $('.detail_buttons a[href="' + key + '"]').parent().addClass('active');
                }
            }
        });
    }
}

function initDetailSlider() {
    if ($('#details-slider').length > 0) {
        $slider = $('#details-slider');
        $thumbs = $('#details-thumbs');

        $slider.slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '#details-thumbs'
        });

        $thumbs.slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            asNavFor: '#details-slider'
        });
    }
}

function initStreetview() {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': $('#gmap_streetview').data('address')}, function (results, status) {
        var lookTo = results[0].geometry.location;
        if (status == google.maps.GeocoderStatus.OK) {
            var panoOptions = {
                position: lookTo,
                panControl: false,
                addressControl: false,
                linksControl: false,
                zoomControlOptions: false
            };
            var pano = new google.maps.StreetViewPanorama(document.getElementById('gmap_streetview'), panoOptions);
            var service = new google.maps.StreetViewService;
            service.getPanoramaByLocation(pano.getPosition(), 50, function (panoData) {
                if (panoData != null) {
                    var panoCenter = panoData.location.latLng;
                    var heading = google.maps.geometry.spherical.computeHeading(panoCenter, lookTo);
                    var pov = pano.getPov();
                    pov.heading = heading;
                    pano.setPov(pov);
                } else {
                    $('#gmap_streetview').html('Kan streetview niet genereren');
                }
            });
        } else {
            $('#gmap_streetview').html('Kan streetview niet genereren');
        }
    });
}

function initMaps() {
    var latlng = new google.maps.LatLng($('#gmap_locatie').data('lat'), $('#gmap_locatie').data('lng'));

    map = new google.maps.Map(document.getElementById("gmap_locatie"), {
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: latlng,
        scrollwheel: false
    });

    var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: '/img/icon-map.png'
    });
}

function initDetailOmschrijving() {
    if ($('a.meer').length > 0) {
        $('a.meer').click(function (e) {
            e.preventDefault();
            $('.description_short').slideUp(function () {
                $('.description_long').slideDown();
            });
        });
    }
}

// function initContact() {
//     if ($('#contact').length > 0) {
//         var latlng = new google.maps.LatLng($('#maps').data('lat'), $('#maps').data('lng'));
//
//         map = new google.maps.Map(document.getElementById("maps"), {
//             name :'test',
//             zoom: 15,
//             mapTypeId: google.maps.MapTypeId.ROADMAP,
//             center: latlng,
//             scrollwheel: false
//         });
//
//         var marker = new google.maps.Marker({
//             position: latlng,
//             map: map,
//             icon: '/img/icon-map.png'
//         });
//     }
// }

function initAanbod() {
    initViewToggle();
}

function initViewToggle() {
    if ($('.view-toggle').length > 0) {
        $('.view-map').hide();

        $('.view-toggle').click(function () {

            $('.view-toggle').removeClass('active');
            $(this).addClass('active');

            $('.view').hide();
            $('.' + $(this).data('toggle')).show();

            localStorage['view-toggle'] = $(this).data('toggle');

            if ($(this).data('toggle') == 'view-map') {

                $('.sort_wrapper').hide();

                var view = $(this).data('method');

                $.ajax({
                    dataType: "json",
                    url: window.location.origin + window.location.pathname + '.json' + window.location.search,
                    method: 'GET',
                    async: true
                }).done(function (data) {
                    initMap(data);
                });
            } else {
                $('.sort_wrapper').show();
            }
        });
    }

    if (localStorage['view-toggle'] == 'view-map') {
        $('.view-toggle[data-toggle=view-map]').click();
    }
}

function initMap(data) {
    var bounds = new google.maps.LatLngBounds();
    var infowindow = new google.maps.InfoWindow();

    map = new google.maps.Map(document.getElementById("maps"), {
        zoom: 12,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    markers = [];
    $(data).each(function (i, object) {

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(object.latitude, object.longitude),
            map: map,
            icon: '/img/icon-map.png'
        });

        bounds.extend(marker.position);

        google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
                infoBubble = new InfoBubble({
                    map: map,
                    content: '<a href="' + object.url + '" class="object">\n\
                                <figure>\n\
                                    <img src="' + object.hoofdfoto + '" alt="' + object.adres + ' ' + object.plaats + '">\n\
                                    <figcaption>' + object.prijs + '</figcaption>' + object.label + '\n\
                                </figure>\n\
                                <div class="text">\n\
                                    <h2>' + object.adres + '</h2>\n\
                                    <h3>' + object.plaats + '</h3>\n\
                                </div>\n\
                            </a>',
                    shadowStyle: 0,
                    padding: 0,
                    borderRadius: 0,
                    arrowSize: 0,
                    borderWidth: 0,
                    minWidth: 320,
                    maxWidth: 320,
                    closeSrc: '/img/infobubble-close.png'
                });

                infoBubble.open(map, marker);
            }
        })(marker, i));

        markers.push(marker);
    });

    map.fitBounds(bounds);

    var mc = new MarkerClusterer(map, markers, {
        imagePath: '/img/m'
    });
}

function initObjectPano() {
    $('[id^=pano-]').each(function (index) {
        id = $(this).attr('data-id');
        data = {
            js: '/js/pano/pano.js',
            swf: '/js/pano/pano.swf',
            xml: window.location.origin + window.location.pathname + '/pano/' + id + '.xml',
            target: 'pano-' + id,
            html5: 'prefer',
            passQueryParameters: true
        };
        embedpano(data);
    });
}

function initHuisVerkopen() {
    if ($('#huisverkopen').length) {
        $('.huisverkopen').click(function (event) {
            event.preventDefault();

            $('html, body').animate({
                scrollTop: $('#contactverkopen').offset().top - 200
            }, 500);
        });
    }
}

function initTimeline() {
    if ($('#overons').length) {
        $('.timeline .line').each(function () {
            var height = $(this).find('.text span p').outerHeight();
            $(this).find('.text span').css('height', height + 40);

            if ($(window).width() >= 1024) {
                $(this).find('.text').css('height', $(this).outerHeight());
                $(this).find('.image').css('height', $(this).outerHeight());
            } else {
                $(this).find('.text').css('height', height + 40);
                $(this).find('.image').css('height', '120px');
            }
        });
    }
}

function initServices() {
    if ($('#services').length > 0) {
        $('#services .services_wrapper').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 4,
            responsive: [

                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
}

function initMatchheight() {
    if ($('.matchheight').length > 0) {
        $('.matchheight').matchHeight();
    }
}

function villaProjects() {
    if ($('#projects').length > 0) {
        $('#projects .wrapper').slick({
            dots: false,
            prevArrow: $('.icon-chevron-left'),
            nextArrow: $('.icon-chevron-right'),
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
}

